import { render, staticRenderFns } from "./HCreditos.vue?vue&type=template&id=73ae55eb&"
import script from "./HCreditos.vue?vue&type=script&lang=js&"
export * from "./HCreditos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports